import supreme from '../supreme'
import jumpMgr from '../task/jumpMgr'
/**
 *@exports baseView
 *@desc Vue 的基类，用来全局扩展Vue ，提供一些增强型方法
 *@author lei.you
 *@date 2018/02/08
 * */
var baseView = {

    methods: {
        /**
         * @method :clearCache
         * @desc 指定删掉那个页面的缓存，一般情况下都是删掉index 的缓存
         * @param {vue} view 被删除的页面 如果不传默认是this
         * */
        clearCache(view) {
            if (!view) {
                view = this;
            }

            var _uid = view._uid;
            view.$options.parent && view.$options.parent.cache && (() => {
                for (var c in view.$options.parent.cache) {
                    var cache = view.$options.parent.cache[c];
                    if (cache.componentInstance&&cache.componentInstance._uid == _uid) {

                        view.$options.parent && view.$options.parent.keys && (() => {
                            for (var i = 0; i < view.$options.parent.keys.length; i++) {
                                if (view.$options.parent.keys[i] == c) {
                                    view.$options.parent.keys.splice(i--, 1);
                                }
                            }
                        })();

                        delete view.$options.parent.cache[c];
                    }
                }
            })();
            return this;
        },
        /**
         * @desc 辅助跳转，跳转不会记录到taskStack 中
         * @param {string}  pathName 跳转的路由名称
         * @param {object}  params 跳转携带的参数
         * @return {supreme} 返回supreme 本身
         *
         * */
        forward(pathName,params){
            jumpMgr.forward(pathName,params);
            return this;
        },
      /**
       * @method :goto
       * @desc 跳转
       * @param {object} {userCache:ture||false} useCache 动态指定下个页面是否使用缓存
       * @return {vue}
       *
       * */
        goto(pathName, params = {}) {
            jumpMgr.goto(pathName,params);
            return this;
        },
        /**
         *
         * @method :backToPage
         * @description 回退到某一个页面
         * @param  model ={
     *            step, 指定回退 步数  正整数
     *            name, 指定回退到最近的指定名字的task
     *            step name 不能同时指定，如果同时指定会优先step
     *            clearCache true false 是否清缓存
     *          }
         * @param params 回退携带的参数
         * @return {vue}
         *
         * */
        backToPage(model = {}, params) {
            jumpMgr.backToPage(model,params);
            return this;
        },
        /**
         * @method :back
         * @description 回退上个页面
         * @pamam {object}{userCache:ture||false} useCache 回退到的页面是否使用缓存 {clearCache:true||false} 清除掉回退到页面的缓存
         * @return {vue}
         * */
        back(params = {}) {
            jumpMgr.back(params);
            return this;
        },
        /**
         * @param {string} param key 参数名
         * @return 获取url上的参数
         * */
        getQueryString(key){
            return supreme.getQueryString(key)
        },
        /**
         * @description 自定义钩子函数需要用户覆盖, hybrid 开发中调用的一个特殊事件
         * @param
         * */

        onAppear(){
          //console.log('this is baseview appear');
          // todo
        },

    }


};

export default baseView
